import React from "react";
import { RxArrowRight } from "react-icons/rx";

export default function InfoCard({ title, description, onClick, icon }) {
    return (
        <div 
            className="group relative flex flex-col items-center text-center p-5 bg-white hover:bg-gradient-to-b hover:from-white hover:to-gray-50 transition-all duration-300 rounded-lg shadow-sm hover:shadow-md"
        >
            {/* Top decorative line */}
            <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-red-500 to-red-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            
            {/* Icon Section */}
            <div className="mb-4">
                <div className="relative">
                    <div className="absolute inset-0 bg-red-100 rounded-full blur-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    <div className="relative flex items-center justify-center w-12 h-12 rounded-lg bg-gradient-to-br from-red-50 to-white shadow-sm group-hover:shadow-md transition-all duration-300">
                        <div className="text-red-500 group-hover:text-red-600 transition-colors duration-200 text-2xl">
                            {icon}
                        </div>
                    </div>
                </div>
            </div>

            {/* Content Section */}
            <div className="mb-4">
                <h3 className="text-lg font-semibold text-gray-900 font-OpenSans group-hover:text-red-600 transition-colors duration-300 mb-2">
                    {title}
                </h3>
                <p className="text-sm text-gray-600 font-OpenSans leading-relaxed">
                    {description}
                </p>
            </div>

            {/* Action Button */}
            <div className="flex justify-center">
                <button
                    onClick={onClick}
                    className="group/btn relative inline-flex items-center justify-center gap-1.5 py-1.5 px-3 text-sm font-medium text-white bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 rounded-md shadow-sm hover:shadow-md transition-all duration-300"
                >
                    <span>Try Now</span>
                    <RxArrowRight className="w-4 h-4 transition-transform duration-300 group-hover/btn:translate-x-1" />
                    {/* Button shine effect */}
                    <span className="absolute inset-0 overflow-hidden rounded-md">
                        <span className="absolute inset-0 -translate-x-full group-hover/btn:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-white/20 to-transparent" />
                    </span>
                </button>
            </div>
        </div>
    )
}    